export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7109_11917)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 3.375C20.7959 3.375 23.3272 4.50828 25.1595 6.34054C26.9917 8.17281 28.125 10.7041 28.125 13.5C28.125 16.2959 26.9917 18.8272 25.1595 20.6595C23.3272 22.4917 20.7959 23.625 18 23.625C15.2041 23.625 12.6728 22.4917 10.8405 20.6595C9.00828 18.8272 7.875 16.2959 7.875 13.5C7.875 10.7041 9.00828 8.17281 10.8405 6.34054C12.6728 4.50828 15.2041 3.375 18 3.375Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6485 11.1084C18.3087 11.1084 18.9064 11.376 19.339 11.8086C19.7716 12.2412 20.0392 12.8389 20.0392 13.4991C20.0392 14.1593 19.7716 14.7569 19.339 15.1896C18.9064 15.6222 18.3087 15.8898 17.6485 15.8898C16.9883 15.8898 16.3907 15.6222 15.958 15.1896C15.5254 14.7569 15.2578 14.1593 15.2578 13.4991C15.2578 12.8389 15.5254 12.2412 15.958 11.8086C16.3907 11.376 16.9883 11.1084 17.6485 11.1084Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                />
                <path
                    d="M18.4805 10.7556C19.1833 8.0527 19.9261 6.52442 20.5951 6.71287C21.5986 6.99554 23.1135 7.95944 22.9528 9.2159C22.8168 10.2794 21.5541 11.7904 20.0156 13.0716"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                />
                <path
                    d="M19.7653 14.9461C22.1187 16.4498 23.3427 17.6285 22.9567 18.2065C22.3778 19.0736 20.9929 20.2165 19.8476 19.6754C18.8782 19.2174 17.8313 17.5495 17.0883 15.6904"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                />
                <path
                    d="M14.9794 14.4092C12.3978 15.4745 10.7303 15.8011 10.4781 15.1534C10.1 14.1818 9.95806 12.3919 11.0582 11.764C11.9894 11.2326 13.9561 11.3317 15.9052 11.7894"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                />
                <path d="M16.3143 23.0625L15.2422 28.8399" stroke="#3EAE60" strokeWidth="1.6875" />
                <path d="M19.6875 23.0625L20.7902 28.7837" stroke="#3EAE60" strokeWidth="1.6875" />
                <path d="M24.75 25.875V28.0139" stroke="#3EAE60" strokeWidth="1.6875" strokeLinecap="round" />
                <rect x="7.59375" y="28.9688" width="20.8125" height="2.8125" rx="1.40625" stroke="#3EAE60" strokeWidth="1.6875" />
            </g>
            <defs>
                <clipPath id="clip0_7109_11917">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
